import { RoleHistoryLogEnum } from '../../enums/role/role-history-log.enum';
import { LogTypeEnum } from '../../enums/logType/log-type.enum';
import { Constants } from '../constants';
export class HistoryLogsEntry {
    role;
    who;
    when;
    action;
    type;
    data;
    key;
    constructor(logEntry, useCase) {
        this.key = logEntry.key ?? '';
        this.role = HistoryLogsEntry.getRole(logEntry.rol);
        this.who = logEntry.who;
        this.when = logEntry.when * 1000;
        this.action = Constants.logAction(logEntry.action, useCase);
        this.type = HistoryLogsEntry.getType(logEntry);
        this.data = HistoryLogsEntry.getData(logEntry, this.type);
    }
    static getRole(role) {
        return ([RoleHistoryLogEnum.remote_user, RoleHistoryLogEnum.system, RoleHistoryLogEnum.workshop_user].find((a) => role.includes(a)) ??
            RoleHistoryLogEnum.bdeo_user);
    }
    static getType(logEntry) {
        if (logEntry.key && Constants.LOG_LANG_KEYS[logEntry.key]) {
            return Constants.LOG_LANG_KEYS[logEntry.key];
        }
        const match = Object.keys(Constants.INFO_COMPONENTS).find((component) => {
            return Object.prototype.hasOwnProperty.call(logEntry, component);
        });
        if (!match) {
            return LogTypeEnum.text;
        }
        return Constants.INFO_COMPONENTS[match];
    }
    static getData(logEntry, type) {
        // TODO Tarea de refactor para log, estas clases no tienen sentido que exitan
        if (type === LogTypeEnum.paintSystemUpdated) {
            return logEntry.data;
        }
        if (type === LogTypeEnum.damageChanged) {
            return {
                ...logEntry.data,
                part: 'part' in logEntry && typeof logEntry.part === 'string' ? logEntry.part : undefined
            };
        }
        let data = {};
        const componentsFromType = Object.entries(Constants.INFO_COMPONENTS)
            .filter(([, value]) => value === type)
            .map(([element]) => element);
        componentsFromType.forEach((component) => {
            const entries = Object.entries(logEntry);
            const componentData = entries
                .filter(([key]) => key === component)
                .map(([key, value]) => {
                if (component === 'repair_centers' || component === 'pieces_list') {
                    return {
                        title: key,
                        items: value
                    };
                }
                if (component === 'conceptInfo') {
                    return {
                        operation: ((value || {}).estimation || {}).operation || '',
                        detail: ((value || {}).estimation || {}).description || ''
                    };
                }
                if (component === 'commentInfo') {
                    return {
                        detail: (value || {}).text
                    };
                }
                if (component === 'repairCenterInfo') {
                    return {
                        detail: (value || {}).providerName
                    };
                }
                if (component === 'field') {
                    const [, oldValue] = entries.find((entry) => entry.includes('oldValue')) || '';
                    const [, newValue] = entries.find((entry) => entry.includes('newValue')) || '';
                    return {
                        oldValue,
                        newValue,
                        field: value
                    };
                }
                if (component === 'block-retry') {
                    return {
                        detail: value
                    };
                }
                if (component !== 'oldValue' && component !== 'newValue') {
                    return value;
                }
                return {};
            })
                .at(0);
            data = { ...data, ...(componentData ?? {}) };
        });
        return data;
    }
}
